import React from "react";
import { HeroStatsProps, backgroundColors } from "../types";
import sortBySortValue from "@/utils/functions/sortBySortValue";

const Default = ({
  courseDetails,
  background = "transparent",
}: HeroStatsProps) => {
  const courseDetailsLength = courseDetails ? courseDetails.length : 0;
  const backgroundColorClass = backgroundColors[background];
  return (
    <div
      className={`${backgroundColorClass} flex flex-col gap-12 justify-center ${courseDetailsLength > 2 ? "lg:flex-row lg:gap-0" : "md:flex-row md:gap-0"}`}
    >
      {sortBySortValue(courseDetails || []).map((detail) => (
        <div
          className={`flex flex-grow justify-center basis-full ${courseDetailsLength > 2 ? "lg:border-r lg:border-white" : "md:border-r md:border-white"} last:border-none`}
          key={detail.heading}
        >
          <div className="text-center px-4" key={detail.heading}>
            <p className="text-primary-foreground font-black text-4xl italic">
              {detail.heading}
            </p>
            <p className="text-primary-foreground mb-0">{detail.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Default;
